import videojs, { VideoJsPlayer } from 'video.js';

import CustomMenuButton from '@src/components/CustomMenuButton';
import { Event } from '@src/types/event';

const SubsCapsButton = videojs.getComponent('SubsCapsButton');
const SubsCapsMenuItem = videojs.getComponent('SubsCapsMenuItem');
const OffTextTrackMenuItem = videojs.getComponent('OffTextTrackMenuItem');
const TextTrackMenuItem = videojs.getComponent('TextTrackMenuItem');

function customHandleClick(
  this: videojs.Component,
  event: videojs.EventTarget.Event
) {
  this.player_.trigger(Event.X_CLICK_SUBTITLE, {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    label: this.options_.label,
  });

  TextTrackMenuItem.prototype.handleClick.call(this, event);
}

SubsCapsMenuItem.prototype.handleClick = customHandleClick;
OffTextTrackMenuItem.prototype.handleClick = customHandleClick;

class CustomSubsCapsButton extends SubsCapsButton {
  constructor(player: VideoJsPlayer, options?: videojs.TrackButtonOptions) {
    super(player, options);
    CustomMenuButton.prototype.setupHandleMouseDown.call(this);
  }
}

CustomSubsCapsButton.prototype.createMenu =
  CustomMenuButton.prototype.createMenu;

// override video.js original SubsCapsButton
videojs.registerComponent('SubsCapsButton', CustomSubsCapsButton);

export default CustomSubsCapsButton;
